var constants_1 = require('./constants');
var dispatcher_1 = require('./dispatcher');
function goForward() {
    dispatcher_1.default.dispatch({
        type: constants_1.ActionKind.GoForward,
    });
}
exports.goForward = goForward;
function goBack() {
    dispatcher_1.default.dispatch({
        type: constants_1.ActionKind.GoBack,
    });
}
exports.goBack = goBack;
function createInnerFrame(iframe) {
    dispatcher_1.default.dispatch({
        type: constants_1.ActionKind.CreateInnerFrame,
        inner_frame: iframe,
    });
}
exports.createInnerFrame = createInnerFrame;
function openURL(url) {
    dispatcher_1.default.dispatch({
        type: constants_1.ActionKind.OpenURL,
        url: url,
    });
}
exports.openURL = openURL;
//# sourceMappingURL=actions.js.map